import { Component } from '@angular/core';

@Component({
  selector: 'app-add-edit-user-page-skeleton',
  templateUrl: './add-edit-user-page-skeleton.component.html',
  styleUrls: ['./add-edit-user-page-skeleton.component.scss'],
})
export class AddEditUserPageSkeletonComponent {}
